import { formatCountryLabel } from "lib/utils/countryLabels";

export default function AdminManagerRequestCard({
  managerRequests = [],
  managerRequestError = "",
  onReview,
}) {
  return (
    <section className="roleAdminPanel managerRequestCard">
      <div className="roleAdminPanel__header">
        <h3>매니저 생성 승인</h3>
        <span className="hint muted">{managerRequests.length}건 대기</span>
      </div>
      <div className="roleAdminTableWrap">
        <table className="roleAdminTable managerRequestTable">
          <thead>
            <tr>
              <th>요청자</th>
              <th>생성 계정</th>
              <th>국가</th>
              <th>요청일</th>
              <th className="tRight">처리</th>
            </tr>
          </thead>
          <tbody>
            {managerRequests.map((request) => {
              const payload =
                request.payload && typeof request.payload === "object"
                  ? request.payload
                  : {};

              return (
                <tr key={request.id}>
                  <td>
                    {payload.requested_by_name ||
                      payload.requested_by_email ||
                      "-"}
                  </td>
                  <td>
                    {payload.user_name || "-"} /{" "}
                    {payload.email || request.requester_email || "-"}
                  </td>
                  <td>
                    {formatCountryLabel({
                      code:
                        payload.country_code ??
                        payload.country_id ??
                        payload.country,
                      default_name: payload.country_name ?? payload.country,
                    })}
                  </td>
                  <td>
                    {String(request.created_at || "-")
                      .replace("T", " ")
                      .slice(0, 16)}
                  </td>
                  <td className="tRight managerRequestActions">
                    <button
                      className="roleAdminSecondaryButton"
                      onClick={() => onReview?.(request.id, "reject")}
                      type="button"
                    >
                      거절
                    </button>
                    <button
                      className="roleAdminPrimaryButton"
                      onClick={() => onReview?.(request.id, "approve")}
                      type="button"
                    >
                      승인
                    </button>
                  </td>
                </tr>
              );
            })}
            {managerRequests.length === 0 ? (
              <tr>
                <td className="roleAdminTable__empty" colSpan={5}>
                  {managerRequestError ||
                    "대기 중인 매니저 생성 요청이 없습니다."}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </section>
  );
}
